import React from 'react';

import PropTypes from 'prop-types';

import { XSS_FILTER_OPTIONS } from 'apps/promo/constants/Constants';
import { filterXSS } from 'xss';

import { Container, RowButton, SubTitle, Title } from './styles';
import { LightButton } from '../LightButton/LightButton';

export const LightHeaderPanel = (props) => {
    return (
        <Container indentCompact={props.indentCompact}>
            <Title useThemeColor={props.useThemeColor} isCentered={props.isCentered}>
                {props.title}
            </Title>
            {props.subtitle && (
                <SubTitle useThemeColor={props.useThemeColor} dangerouslySetInnerHTML={{ __html: filterXSS(props.subtitle, XSS_FILTER_OPTIONS) }} />
            )}
            {props.buttonRowCaption && (
                <RowButton>
                    <LightButton
                        variant="row"
                        size={'tight'}
                        negativeMargin
                        caption={props.buttonRowCaption}
                        onClick={props.buttonRowOnClick}
                        href={props.buttonRowHref}
                    />
                </RowButton>
            )}
        </Container>
    );
};

LightHeaderPanel.propTypes = {
    indentCompact: PropTypes.bool,
    isCentered: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    buttonRowType: PropTypes.string,
    buttonRowCaption: PropTypes.string,
    buttonRowOnClick: PropTypes.func,
    buttonRowHref: PropTypes.string,
};
